import { render, staticRenderFns } from "./bout_create.vue?vue&type=template&id=6f7283a6&"
import script from "./bout_create.vue?vue&type=script&lang=js&"
export * from "./bout_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports